module.exports = __webpack_public_path__ + "static/tegar-d1308446ee6d218ac0913b6256a19b78.png";